export default __webpack_public_path__ + "static/meshery-operator-v0.5.0-cafafae3b39293316587ce4837b01eef.webp";